export default __webpack_public_path__ + "static/blockbuster-b75f618ac5bc34d52fa207b22ec6c8f5.svg";